import { render, staticRenderFns } from "./NewProductConfiguratorEditorAccessory.vue?vue&type=template&id=4814bd37"
import script from "./NewProductConfiguratorEditorAccessory.vue?vue&type=script&lang=js"
export * from "./NewProductConfiguratorEditorAccessory.vue?vue&type=script&lang=js"
import style0 from "./NewProductConfiguratorEditorAccessory.vue?vue&type=style&index=0&id=4814bd37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports